<template>
  <div id="popupBox" class="popup">
			<div class="popup-content">
				<div class="popup-header">
					<span class="close" v-on:click="closeModal">×</span>
					<h2 id="popup-title">Details of Distribution</h2>
				</div>
				<div id="popup-main-content" class="popup-main">
					<div id="popup_gridItem_distribution">
						<div class="popup_box_title_container">

							Distribution of period {{ selectedPeriodDisplay }} <sup style="font-size:xx-small;">(1)</sup>
              <div style="float: right;">
                <div class="tooltip">
                  <!-- Tooltip -->
                  <img src="../../assets/information.svg" width="12px;"/>
                  <span class="tooltiptext">
                    This shows the KDE of the probability density distribution for this node.
                    If a highlight has been defined, this will also show in yellow the part of the distribution that would result in values are in the highlighted range.
                    If the highlight was defined in this node itself, this will show the highlighted range in yellow.
                  </span>
                </div>
              </div>
						</div>

            <div style="height: 25px; padding-top: 5px; padding-right: 5px;">
              <div v-if="isThisNodeHighlightOwner" style="text-align: right;">
                <!-- The dot below is the yellow dot that indicates that highlight was defined here -->
                <div class="tooltip">
                  <!-- Tooltip -->
                  <span class="dot"></span>
                  <span class="tooltiptext">
                    This node owns the highlight.
                  </span>
                </div>
              </div>
            </div>
            
						<div id="largedistplot" class="plot">
            </div>
					</div>

					<div id="popup_gridItem_boxplot">
						<div class="popup_box_title_container">
							Development over time
              <div style="float: right;">
                <div class="tooltip">
                  <!-- Tooltip -->
                  <img src="../../assets/information.svg" width="12px;"/>
                  <span class="tooltiptext">
                    This graph shows the boxplot for the original distribution.
                    If multiple periods have been defined, it will show a boxplot for each one to illustrate changes over time.
                  </span>
                </div>
              </div>
						</div>
						<div id="largeboxplot" class="plot"></div>
					</div>

					<div id="popup_gridItem_highlightSlider">

            <div class="popup_box_title_container">
              Highlight / Sensitivity
              <div style="float: right;">
                <div class="tooltip">
                  <!-- Tooltip -->
                  <img src="../../assets/information.svg" width="12px;"/>
                  <span class="tooltiptext">
                    You can select a range of the distribution that is of particular interest.
                    This defines a highlight for this node.
                    All other nodes will then update their distribution previews to show which part of their distributions could lead to a result in the highlighted range.
                    Use the button to remove the highlight again.
                  </span>
                </div>
              </div>
            </div>

            <div style="margin-top:35px; display:flex;">
              <div style="width:420px; padding-left: 110px;">
                <div v-if="isThisNodeHighlightOwner">
                  <!--  Use a slider where tooltips are always visible.
                        We cannot do this if the node is NOT the highlight owner...
                        ...because the initial tooltips would show outdated values.
                   -->
                  <vue-slider
                    :min="min"
                    :max="max"
                    :lazy="true"
                    :order="false"
                    v-model="value"
                    :data="sliderData"
                    :tooltip="'always'"
                    :tooltip-placement="['bottom', 'top']"
                    @change="sliderChanged"
                  ></vue-slider>
                </div>
                <div v-else>
                  <!-- Use a slider where tooltips are not immediately visible -->
                  <vue-slider
                    :min="min"
                    :max="max"
                    :lazy="true"
                    :order="false"
                    v-model="value"
                    :data="sliderData"
                    :tooltip="'active'"
                    :tooltip-placement="['bottom', 'top']"
                    @change="sliderChanged"
                  ></vue-slider>
                </div>
              </div>
              <div v-if="isThisNodeHighlightOwner">
                <button style="margin-left: 30px; width: 80px;" v-on:click="removeHighlight()">Remove highlight</button>
              </div>
              <div v-else>
                <button style="margin-left: 30px; width: 80px;" v-on:click="removeHighlight()" disabled>Remove highlight</button>
              </div>
            </div>

            <div v-if="isThisNodeHighlightOwner" style="text-align: center; margin-top: 30px; font-size: small;">
              {{shareOfDataPointsWithinRangeAsString}} 
            </div>
            <div v-else style="padding-left: 110px; margin-top: 30px; font-size: small;">
              <div v-if="aHighlightHasBeenDefined">
                KL Divergence of original vs. highlighted distribution: {{KLDivergenceAsString}}
              </div>
            </div>

					</div>

          <div id="popup_gridItem_changeDriverSlider">
            <div class="popup_box_title_container">
              Selection of contiguous period
              <div style="float: right;">
                <div class="tooltip">
                  <!-- Tooltip -->
                  <img src="../../assets/information.svg" width="12px;"/>
                  <span class="tooltiptext">
                    If the model is based on multiple periods, you can select a contiguous period here.
                    This allows you to see statistics for this contiguous period and the top drivers of change can be displayed.
                  </span>
                </div>
              </div>
            </div>

            <div style="margin-top:35px; display:flex; justify-content: center;">
              <div v-if="doWeHaveAtLeast2Periods">
                
                <div  style="width:500px; padding-left: 50px;">
                  <vue-slider
                    :min="periodSliderMin"
                    :max="periodSliderMax"
                    :lazy="true"
                    v-model="periodSliderSelectedPeriods"
                    :data="periodSliderData"
                    :marks="true"
                    :enableCross="false"
                    @change="periodSliderChanged"
                  ></vue-slider>
                </div>

              </div>
              <div v-else style="font-size: x-small; width: 100%; text-align:center;">
                <span>
                  There is only a single period in the current model. <br>
                  To analyse a contiguous period, increase the number of periods in this model.
                </span>
              </div>             
            </div>

            <!-- Not required. By removing highlight, this will be reset as well.

            <div v-if="isThisNodeHighlightOwner" style="width: 100%; text-align: right;">
              <button style="width: 80px; margin-right:10px;" v-on:click="removePeriodSelection()">Remove selection</button>
            </div>
            <div v-else>
              <button style="width: 80px; margin-right:10px;" v-on:click="removePeriodSelection()" disabled>Remove selection</button>
            </div>  
            
            -->

          </div>

          <div id="popup_gridItem_differenceToHighlight">
            <div class="popup_box_title_container">
              Original vs. highlight density
              <div style="float: right;">
                <div class="tooltip">
                  <!-- Tooltip -->
                  <img src="../../assets/information.svg" width="12px;"/>
                  <span class="tooltiptext">
                    This table compares the statistics of the original density distribution and the highlight density distribution.
                    The comparison is done for a single selected period, as shown in the distribution illustration.
                  </span>
                </div>
              </div>
              <div v-if="isThisNodeHighlightOwner" style="color: black; margin-top:5px; padding-left: 5px; font-size: x-small;">
                The differences are only visible for nodes where the highlight was not defined. 
              </div>
              <div v-else style="margin-top:5px; padding-left: 0px; padding-right: 0px; font-size: small;">

                <table class="tg">
                  <thead>
                    <tr>
                      <th class="tg-0lax">Metric</th>
                      <th class="tg-0lax">Original</th>
                      <th class="tg-0lax">Highlight</th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- Row 1 -->
                    <tr>
                      <td class="tg-0lax">Quartile 75%</td>
                      <td class="tg-0lax">{{original_quartile75_formattedString}}</td>
                      <td v-if="aHighlightHasBeenDefined" class="tg-0lax">{{highlight_quartile75_formattedString}}</td>
                    </tr>

                    <!-- Row 2 -->
                    <tr>
                      <td class="tg-0lax">Median</td>
                      <td class="tg-0lax">{{original_median_formattedString}}</td>
                      <td v-if="aHighlightHasBeenDefined" class="tg-0lax">{{highlight_median_formattedString}}</td>
                    </tr>

                    <!-- Row 3 -->
                    <tr>
                      <td class="tg-0lax">Quartile 25%</td>
                      <td class="tg-0lax">{{original_quartile25_formattedString}}</td>
                      <td v-if="aHighlightHasBeenDefined" class="tg-0lax">{{highlight_quartile25_formattedString}}</td>
                    </tr>

                    <!-- Row 4 -->
                    <tr>
                      <td class="tg-0lax">Mean</td>
                      <td class="tg-0lax">{{original_mean_formattedString}}</td>
                      <td v-if="aHighlightHasBeenDefined" class="tg-0lax">{{highlight_mean_formattedString}}</td>
                    </tr>
                    
                    <!-- Row 5 -->
                    <tr>
                      <td class="tg-0lax">S.D. (&sigma;)</td>
                      <td class="tg-0lax">{{original_standarddeviation_formattedString}}</td>
                      <td v-if="aHighlightHasBeenDefined" class="tg-0lax">{{highlight_standarddeviation_formattedString}}</td>
                    </tr>
                  </tbody>
                </table>
                
              </div>
            </div>
          </div>

          <div id="popup_gridItem_topDrivers">
            <div class="popup_box_title_container">
              Uncertainty drivers (period {{ selectedPeriodDisplay }}) <sup style="font-size:xx-small;">(3)</sup>
              <div style="float: right;">
                <div class="tooltip">
                  <!-- Tooltip -->
                  <img src="../../assets/information.svg" width="12px;"/>
                  <span class="tooltiptext">
                    This list shows the nodes whose highlight density distributions deviate most from their original distributions.
                    This can be interpreted as those nodes contributing most of the uncertainty with respect to the highlighted range of results.
                    The deviation is measured using the Kullback–Leibler divergence.
                  </span>
                </div>
              </div>
            </div>
            <div v-if="!isThisNodeHighlightOwner" style="margin-top:5px; padding-left: 5px; font-size: x-small;">
              To show the nodes with the largest distribution difference, please highlight a range on the left. 
            </div>
            <div v-else style="margin-top:5px; padding-left: 5px;">
              <div style="font-size: x-small;">
                The bar plot below shows up to {{maxNumberOfDriversShown}} nodes with the largest deviation (KL Divergence).
              </div>
              <div style="display:flex; align-items: center;">
                <input type="checkbox" id="checkboxPredecessors" name="checkboxPredecessors" style="width: auto;" v-model="onlyShowPredecessors">
                <label for="checkboxPredecessors" style="font-size: x-small;">Only show predecessor nodes</label>
              </div>
              <div id="driversBarplot">
                <div id="loading">
                  <img class="loading" src="../../assets/loading.svg"/>
                </div>
              </div>
            </div>
          </div>


					<div id="popup_gridItem_statistics">
						<div class="popup_box_title_container">
							Statistics on the sum over selected periods
              <div style="float: right;">
                <div class="tooltip">
                  <!-- Tooltip -->
                  <img src="../../assets/information.svg" width="12px;"/>
                  <span class="tooltiptext">
                    This table shows the statistics after having summed up the values across periods.
                    This can be useful to see, for example, the statistics for a whole year if each period is one quarter.
                  </span>
                </div>        
              </div>
						</div>
            <div style="margin-top:5px; padding-left: 0px; padding-right: 0px; font-size: small;">
              <div style="font-size: x-small;">
                <div v-if="periodSliderSelectedPeriods[0] != periodSliderSelectedPeriods[1]">
                  Showing statistics for the <em>sum</em> of values for period {{periodSliderSelectedPeriods[0]}} to {{periodSliderSelectedPeriods[1]}}.
                </div>
                <div v-else>
                  Showing statistics for the single selected period {{periodSliderSelectedPeriods[0]}}.
                </div>
              </div>
              <table class="tg">
                <thead>
                  <tr>
                    <th class="tg-0lax">Metric</th>
                    <th class="tg-0lax">Value</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Row 1 -->
                  <tr>
                    <td class="tg-0lax">Quartile 75%</td>
                    <td class="tg-0lax">{{summed_statistics_quartile75}}</td>
                  </tr>

                  <!-- Row 2 -->
                  <tr>
                    <td class="tg-0lax">Median</td>
                    <td class="tg-0lax">{{summed_statistics_median}}</td>
                  </tr>

                  <!-- Row 3 -->
                  <tr>
                    <td class="tg-0lax">Quartile 25%</td>
                    <td class="tg-0lax">{{summed_statistics_quartile25}}</td>
                  </tr>

                  <!-- Row 4 -->
                  <tr>
                    <td class="tg-0lax">Mean</td>
                    <td class="tg-0lax">{{summed_statistics_mean}}</td>
                  </tr>

                  <!-- Row 5 -->
                  <tr>
                    <td class="tg-0lax">S.D. (&sigma;)</td>
                    <td class="tg-0lax">{{summed_statistics_stdev}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
					</div>

          <div id="popup_gridItem_topDriversOfChange">
            <div class="popup_box_title_container">
              Top drivers of change for selected period
              <div style="float: right;">
                <div class="tooltip">
                  <!-- Tooltip -->
                  <img src="../../assets/information.svg" width="12px;"/>
                  <span class="tooltiptext">
                    This overview shows the top drivers of change for the contiguous period selected above.
                    These nodes are upstream with respect to the node where the period was defined.
                  </span>
                </div>
              </div>

            </div>
          </div>

					<div id="popup_gridItem_download">
						<div class="popup_box_title_container">
							Download data <sup style="font-size:xx-small;">(4)</sup>
              <div style="float: right;">
                <div class="tooltip">
                  <!-- Tooltip -->
                  <img src="../../assets/information.svg" width="12px;"/>
                  <span class="tooltiptext">
                    You can download the raw data for this node in *.csv format here.
                    Whereas visualisations may not be able to show all data points, the *.csv files will contain all of them.
                  </span>
                </div>
              </div>
						</div>
						<div style="padding-left: 5px; margin-top: 5px;">
							<div style="display: inline-block; width: 60%; font-size: small;"><b>Probability density</b> ("Distribution")</div>
							<button style="display: inline-block;" v-on:click="download_data('density')">Download</button>
						</div>
						<div style="padding-left: 5px; margin-top: 5px;">
							<div style="display: inline-block; width: 60%; font-size: small;"><b>Boxplots</b> (each period and sum)</div>
							<button style="display: inline-block;" v-on:click="download_data('boxplots')">Download</button>
						</div>
						<div style="padding-left: 5px; margin-top: 5px; font-size: small;">
							<div style="display: inline-block; width: 60%;"><b>All drivers</b></div>
							<button style="display: inline-block;" v-on:click="download_data('drivers')">Download</button>
						</div>
						<div style="padding-left: 5px; margin-top: 5px; font-size: small;">
							<div style="display: inline-block; width: 60%;"><b>Raw data of node</b> (all samples, all periods)</div>
							<button style="display: inline-block;" v-on:click="download_data('rawdata')">Download</button>
						</div>
					</div>

          <div id="popup_gridItem_comment">
            <div class="popup_box_title_container">
              Free-text comments on the assumptions
              <div style="float: right;">
                <div class="tooltip">
                  <!-- Tooltip -->
                  <img src="../../assets/information.svg" width="12px;"/>
                  <span class="tooltiptext">
                    You can use this free text field to store information about this node, such as assumptions underlying the parameter settings.
                  </span>
                </div>
              </div>
            </div>
            <textarea id="popup_comment" style="width: 100%" v-model="nodeComment"  v-on:blur="handleBlur" rows="7" placeholder="Optional free-text comments about assumptions etc...">
            </textarea>
          </div>

				</div>
				<div class="popup-footer">
					&nbsp;&#9400; EY-Parthenon 2020
				</div>
			</div>
		</div>
</template>

<script>
  import Vue from 'vue';
  import * as d3 from 'd3';
  import highlightSelectedRange from '../../util/density/highlightSelectedRange';
  import plotDetailPopUpGraph from '../../util/density/plotDetailPopUpGraph';
  import displayBoxPlot from '../../util/density/displayBoxPlot';
  import download from '../../util/download'; // to download data
  import * as SPURS from '../../../SPURS.config.js';
  import updateHighlightsAndKL from '../../util/density/updateHighlightsAndKL';
  import updateChangeDrivers from '../../util/density/updateChangeDrivers';

  // Both sliders
  import VueSlider from 'vue-slider-component'
  import 'vue-slider-component/theme/default.css'
  
/*   // RangeSlider (for distribution)
  Vue.component('vue-slider', VueSlider);

  // PeriodSlider (for periods)
  // import PeriodSlider from './PeriodSlider.vue';
  Vue.component('vue-period-slider', VueSlider); */

  export default {
    name: 'PopUp',
    components: {
      VueSlider
    },
    props: ['selectedPeriod', 'data', 'editor', 'modules'],
    watch: {
      onlyShowPredecessors: function (val, oldVal) {
        // Prepare data again to reflect changed customer selection
        this.showTopDrivers();
      }
    },

    data: () => {
      return {

        // RangeSlider
        sliderData: [], // the possible values (steps) we allow the sliders to take
        min: 0, // the left end of the slider (the lowest possible value the slider allows)
        max: 0, // the right end of the slider (the highest possible value the slider allows)
        value: ['0', '0'], // the actual slider positions
        
        // PeriodSlider
        periodSliderData: [], // possible values
        periodSliderSelectedPeriods: ["1", "1"], // must be strings apparently
        periodSliderMin: 1, // note: periods are 1-indexed here since they are user-facing!
        periodSliderMax: 1,
        doWeHaveAtLeast2Periods: false,

        activeModule: undefined,
        
        shareOfDataPointsWithinRangeAsString: '',
        shareOfDataPointsWithinRange: undefined,
        idOfEmittingNode: undefined,
        uidOfEmittingVueDistPreview: undefined,
        dataWatcher: undefined,
        distValuesForSelectedTimeSlice: undefined, // 10000 values for the period (1-dim array)
        density: undefined,                         // a few dozen values for the distribution plot (2-dim array of x and prob density)
        densityHighlight: undefined,
        matrixCloneForDownload: undefined,          // full matrix (array of arrays) of all data points for all time slices
        statisticsForDownload: undefined,         // object containing the statistics for all time slices
        nodeComment: undefined, //
        KLDivergence: undefined,
        KLDivergenceAsString: '',

        isThisNodeHighlightOwner: false,
        isThisNodePeriodSelectionOwner: false,

        allDriversForExport: undefined,
        topUpToXDrivers: [],
        maxNumberOfDriversShown: undefined,
        // the following lines are for comparing stats of blue and yellow curve
        original_quartile25_formattedString: undefined,
        highlight_quartile25_formattedString: undefined,
        original_mean_formattedString: undefined,
        highlight_mean_formattedString: undefined,
        original_median_formattedString: undefined,
        highlight_median_formattedString: undefined,
        original_quartile75_formattedString: undefined,
        highlight_quartile75_formattedString: undefined,
        original_standarddeviation_formattedString: undefined,
        highlight_standarddeviation_formattedString: undefined,

        // the following lines are for the summed-up stats
        summed_statistics_quartile25: undefined,
        summed_statistics_mean: undefined,
        summed_statistics_median: undefined,
        summed_statistics_quartile75: undefined,
        summed_statistics_stdev: undefined,

        onlyShowPredecessors: true,
        aHighlightHasBeenDefined: false,
      }
    },
    computed: {
      selectedPeriodDisplay() {
        return parseInt(this.selectedPeriod) + 1;
      }
    },
    mounted() {

      let self = this;


      // Reset the sliders to their initial positions (left most position first)
      // Since at this point, we do not know what the position should be (???)
      // Positions MUST be strings.
      this.value = ['0', '0'];
      this.periodSliderSelectedPeriods = ['1', '1'];

      this.periodMax = parseInt(Vue.prototype.$globalSharedData.numberOfPeriods);
      // console.log('periodMax', this.periodMax)
      if (this.periodMax > 1){
        this.doWeHaveAtLeast2Periods = true;
      }

      let tmpList = [];
      for (let i = 1; i <= this.periodMax; i++) {
          tmpList.push(i);
      }
      this.periodSliderData = tmpList;
      

      if (typeof Vue.prototype.$globalSharedData.idOfNodeThatOwnsHighlight != "undefined"){
        this.aHighlightHasBeenDefined = true;
      } else {
        this.aHighlightHasBeenDefined = false;
      }

      // Event listener for node comments
      this.$eventHub.$on('receiveCommentForNodeIDEvent', this.updateComment); // event listener to update the comment of this node

      // Event listener for the data
      // This listens to changes of popup data but not the slider
      this.dataWatcher = this.$watch('data', (newData) => {
        self.refreshModalData(newData)
      });

      this.refreshModalData(this.data);

      // request this node's comment
      Vue.prototype.$eventHub.$emit("returnCommentForNodeIDEvent", this.idOfEmittingNode);

      this.maxNumberOfDriversShown = SPURS.maxNumberOfDriversShown;

    },

    methods: {
      invertRange(){
        let previous_min = this.min;
        let previous_max = this.max;
        this.min = previous_max;
        this.max= previous_min;
      },
      handleBlur(){
        // alert('I am blurred. ' + this.nodeComment);
        Vue.prototype.$eventHub.$emit("updateCommentForNodeByIDEvent", [this.idOfEmittingNode, this.nodeComment]);
      },

      updateComment(value){
        this.nodeComment = value;
      },

      removeHighlight(){

        // To remove the highlight, we need to:
        // (1) set isThisNodeHighlightOwner to false
        // (2) set the global variable to undefined

        this.isThisNodeHighlightOwner = false;

        // Set slider handles to zero position
        this.value = ['0', '0'];

        // Set all element in the SVG to transparent that relate to highlights
        // These elements got a data-highlight attribute when they were created :)
        let highlight_elements = document.querySelectorAll('[data-highlight="highlight"]');
        highlight_elements.forEach( x=> x.setAttribute("opacity","0"))

        // Reset all highlight-related global variables
        Vue.prototype.$globalSharedData.idOfNodeThatOwnsHighlight = undefined;
        Vue.prototype.$globalSharedData.uuidOfNodeThatOwnsHighlight = undefined;
        Vue.prototype.$globalSharedData.nameOfNodeThatOwnsHighlight = undefined;
        Vue.prototype.$globalSharedData.uidOfVueDistPreviewThatOwnsHighlight = undefined;
        Vue.prototype.$globalHighlightArray = [];
        Vue.prototype.$globalTempHighlightArray = [];

        this.aHighlightHasBeenDefined = false;

        updateHighlightsAndKL();

        // Refresh modal so that the yellow highlight in the popup disappears
        // TODO


      },

      refreshModalData(dataParam) {
        let self = this; // to avoid scope problems

        let {
          givenName,
          width,
          margin,
          height,
          yDensity,
          x,
          density,
          densityHighlight,
          xHighlight,
          yHighlight,
          arrayQuartile25,
          arrayQuartile75,
          arrayMin,
          arrayMax,
          valTotalsMean,
          valTotalsStdev,
          valTotalsMedian,
          matrixClone,
          valTotalsQuartile25,
          valTotalsQuartile75,
          lowerBound,
          upperBound,
          idOfEmittingNode,
          uidOfEmittingVueDistPreview,
          distValuesForSelectedTimeSlice,
          matrixCloneForDownload,
          statisticsForDownload,
          shareOfDataPointsWithinRange,
          minDensityXValueIncludingAddedOnes, // this is a single value (the most left value in the density)
          maxDensityXValueIncludingAddedOnes,  // this is a single value (the most right value in the density)
          KLDivergence,
          dataForComparisonOfDensitiesAsFormattedStrings,
          activeModule,
        } = dataParam;

        // Update summed up statistics
        this.summed_statistics_quartile25 = valTotalsQuartile25;
        this.summed_statistics_mean = valTotalsMean;
        this.summed_statistics_median = valTotalsMedian;
        this.summed_statistics_quartile75 = valTotalsQuartile75;
        this.summed_statistics_stdev = valTotalsStdev;

        this.activeModule = activeModule;
        this.idOfEmittingNode = idOfEmittingNode;
        this.uidOfEmittingVueDistPreview = uidOfEmittingVueDistPreview;

        // Update the range slider
        this.min = arrayMin;
        this.max = arrayMax;
        
        this.distValuesForSelectedTimeSlice = distValuesForSelectedTimeSlice;
        this.density = density;
        this.matrixCloneForDownload = matrixCloneForDownload;
        this.statisticsForDownload = statisticsForDownload;
        this.densityHighlight = densityHighlight;
        this.shareOfDataPointsWithinRange = shareOfDataPointsWithinRange;
        this.shareOfDataPointsWithinRangeAsString = (this.shareOfDataPointsWithinRange*100).toFixed(1) + ' % of data points are within range.';
        this.KLDivergence = KLDivergence;
        if (typeof KLDivergence != 'undefined'){
          this.KLDivergenceAsString = KLDivergence.toFixed(3);
        }

        this.original_quartile25_formattedString = dataForComparisonOfDensitiesAsFormattedStrings.original.quartile25;
        this.highlight_quartile25_formattedString = dataForComparisonOfDensitiesAsFormattedStrings.highlight.quartile25;
        this.original_mean_formattedString = dataForComparisonOfDensitiesAsFormattedStrings.original.mean;
        this.highlight_mean_formattedString = dataForComparisonOfDensitiesAsFormattedStrings.highlight.mean;
        this.original_median_formattedString = dataForComparisonOfDensitiesAsFormattedStrings.original.median;
        this.highlight_median_formattedString = dataForComparisonOfDensitiesAsFormattedStrings.highlight.median;
        this.original_quartile75_formattedString = dataForComparisonOfDensitiesAsFormattedStrings.original.quartile75;
        this.highlight_quartile75_formattedString = dataForComparisonOfDensitiesAsFormattedStrings.highlight.quartile75;
        this.original_standarddeviation_formattedString = dataForComparisonOfDensitiesAsFormattedStrings.original.standarddeviation;
        this.highlight_standarddeviation_formattedString = dataForComparisonOfDensitiesAsFormattedStrings.highlight.standarddeviation;


        // Does this node own the highlight (for the distribution range)?
        if (idOfEmittingNode == Vue.prototype.$globalSharedData.idOfNodeThatOwnsHighlight){
          this.isThisNodeHighlightOwner = true;

          // Only if this node owns the highlight for the distribution range, we re-instate the previously stored values
          this.value = [Vue.prototype.$globalSharedData.lastSliderPositionLowerBoundAsString, Vue.prototype.$globalSharedData.lastSliderPositionUpperBoundAsString]

        } else {
          this.isThisNodeHighlightOwner = false;
        }

        // Does this node own the period selection?
        if (idOfEmittingNode == Vue.prototype.$globalSharedData.idOfNodeThatOwnsPeriodSelection){
          this.isThisNodePeriodSelectionOwner = true;

          // Only if this node owns the period selection, then we re-instate the previously stored values
          // Update the period slider
          if (Vue.prototype.$globalSharedData.lastPeriodSliderPositionLowerBoundAsString){
            // If period slider positions have been defined, then use them
            this.periodSliderSelectedPeriods = [Vue.prototype.$globalSharedData.lastPeriodSliderPositionLowerBoundAsString, Vue.prototype.$globalSharedData.lastPeriodSliderPositionUpperBoundAsString]
          }
          
        } else {
          this.isThisNodePeriodSelectionOwner = false;
        }

        // console.log(statisticsForDownload);
        // console.log('density', density)
        // console.log('densityHighlight', densityHighlight)

        // Before we used: (Math.ceil(this.max) - Math.floor(this.min)) / 1000;
        // This does not work in case of percentages (rounding up or down to integers)
        
        if ((this.max - this.min) != 0){

          let step = (this.max - this.min) / 1000;

          let data = [];
          let val = this.min;

          let numberOfDecimals = 3;

          if (this.max > 10){
            // Reduce the number of decimals we show if the max value is above 10
            numberOfDecimals = 2;
          }

          while (val <= this.max) {
            data.push(val.toFixed(numberOfDecimals));
            val += step;
          }
          this.sliderData = [...data];

        } else {

          // This case can occur if the triangle or square distribution have identical parameters
          // Then min and max are identical

          this.sliderData = [0,1]

        }


        // TODO: Check if this is coupling events
        window.onclick = function(event) {
          let popupBox = document.getElementById('popupBox');
          if (event.target == popupBox) {
            self.closeModal();
          }
        }

        // This is used so we do not always add a graph but delete the old one
        document.getElementById('largedistplot').innerHTML = '';

        let svg = d3.select("#largedistplot")
          .append("svg")
          .attr("width", width + margin.left + margin.right)
          .attr("height", height + margin.top + margin.bottom)
          .append("g")
          .attr("transform", "translate(" + margin.left + "," + margin.top + ")");


        // We use variable y for the y axis
        let y = d3.scaleLinear()
          .range([height, 0])
          .domain([0, d3.max(yDensity)]);

        svg.append("g")
          .call(d3.axisLeft(y)
          .tickFormat(d3.format(".1e"))
          .ticks(10));

        // add title for y axis
        svg.append("g")
          .attr("class", "y axis")
          .call(y)
          .append("text")
          .attr("transform", "rotate(0)")
          .attr("y", 6)
          .attr("dy", "0em")
          .attr("dx", "2.5em")
          .style("text-anchor", "end")
          .style("font-size", "12px")
          .style("font-weight", "bold")
          .style("fill", "currentColor")
          .text("p(x)");
          
        svg.append("g")
          .attr("transform", "translate(0," + height + ")")
          .call(d3.axisBottom(x).ticks(5));


        // add title
        svg.append("g")
          // .attr("class", "x axis")
          // .attr("transform", "translate(0," + (height  + margin.top + 10) + ")")
          .call(x)
          .append("text")             // text label for the x axis
          .attr("x", (width / 2) )
          .attr("y",  height + 20)
          .attr("dy", ".71em")
          .style("text-anchor", "middle")
          .style("font-size", "12px")
          .style("font-weight", "bold")
          .style("fill", "currentColor")
          .text("x");


        // If we have either lowerBound or upperBound
        if (lowerBound || upperBound){

          if (lowerBound < upperBound){
  
            // Rectangle indicating the selected range
            svg.append("rect")
              .attr("opacity", 0.8)
              .attr("fill", "rgb(255, 210, 0)")
              .attr("data-highlight", "highlight") // mark this as part of the highlight, so we can set it transparent later
              .attr("x", x(lowerBound))
              .attr("y", 0)
              .attr("height", height)
              .attr("width", x(upperBound) - x(lowerBound));

          } else {

            // this is the case if the upperBound is below the lowerBound
            // this means we _deselect_ an area in the centre
            // and we need to rectangles from -infinity to upperBound and from lowerBound to +infinity

            // left rectangle
            svg.append("rect")
              .attr("opacity", 0.8)
              .attr("fill", "rgb(255, 210, 0)")
              .attr("data-highlight", "highlight") // mark this as part of the highlight, so we can set it transparent later
              .attr("x", x(minDensityXValueIncludingAddedOnes))
              .attr("y", 0)
              .attr("height", height)
              .attr("width", x(upperBound) - x(minDensityXValueIncludingAddedOnes));

            // right rectangle
            svg.append("rect")
              .attr("opacity", 0.8)
              .attr("fill", "rgb(255, 210, 0)")
              .attr("data-highlight", "highlight") // mark this as part of the highlight, so we can set it transparent later
              .attr("x", x(lowerBound))
              .attr("y", 0)
              .attr("height", height)
              .attr("width", x(maxDensityXValueIncludingAddedOnes) - x(lowerBound));
          }

        } else if (uidOfEmittingVueDistPreview == Vue.prototype.$globalSharedData.uidOfVueDistPreviewThatOwnsHighlight){

          // If the lowerBound and upperBound are not defined,
          // but if this is the highlight owning node, then we use the last slider positions for the rectangle

          if (parseFloat(Vue.prototype.$globalSharedData.lastSliderPositionLowerBoundAsString) < parseFloat(Vue.prototype.$globalSharedData.lastSliderPositionUpperBoundAsString)){
            
            // Rectangle indicating the selected range
            svg.append("rect")
              .attr("opacity", 0.8)
              .attr("fill", "rgb(255, 210, 0)")
              .attr("data-highlight", "highlight") // mark this as part of the highlight, so we can set it transparent later
              .attr("x", x(parseFloat(Vue.prototype.$globalSharedData.lastSliderPositionLowerBoundAsString)))
              .attr("y", 0)
              .attr("height", height)
              .attr("width", x(parseFloat(Vue.prototype.$globalSharedData.lastSliderPositionUpperBoundAsString)) - x(parseFloat(Vue.prototype.$globalSharedData.lastSliderPositionLowerBoundAsString)));        

          } else {

            // we need to rectangles

            // this is the case if the upperBound is below the lowerBound
            // this means we _deselect_ an area in the centre
            // and we need to rectangles from -infinity to upperBound and from lowerBound to +infinity

            // left rectangle
            svg.append("rect")
              .attr("opacity", 0.8)
              .attr("fill", "rgb(255, 210, 0)")
              .attr("data-highlight", "highlight") // mark this as part of the highlight, so we can set it transparent later
              .attr("x", x(minDensityXValueIncludingAddedOnes))
              .attr("y", 0)
              .attr("height", height)
              .attr("width", x(parseFloat(Vue.prototype.$globalSharedData.lastSliderPositionUpperBoundAsString)) - x(minDensityXValueIncludingAddedOnes));

            // right rectangle
            svg.append("rect")
              .attr("opacity", 0.8)
              .attr("fill", "rgb(255, 210, 0)")
              .attr("data-highlight", "highlight") // mark this as part of the highlight, so we can set it transparent later
              .attr("x", x(parseFloat(Vue.prototype.$globalSharedData.lastSliderPositionLowerBoundAsString)))
              .attr("y", 0)
              .attr("height", height)
              .attr("width", x(maxDensityXValueIncludingAddedOnes) - x(parseFloat(Vue.prototype.$globalSharedData.lastSliderPositionLowerBoundAsString)));

          }
        }

        svg.append("path")
          .attr("class", "mypath")
          .datum(density)
          .attr("fill", "#51A7DD")
          .attr("opacity", "0.9")
          .attr("stroke", "#4B4B4B")
          .attr("stroke-width", 1)
          .attr("stroke-linejoin", "round")
          .attr("d",  d3.line()
          .curve(d3.curveBasis)
            .x(function(d) { return x(d[0]); })
            .y(function(d) { return y(d[1]); })
          );


        if (lowerBound || upperBound){

          // left line where range seleced starts
          svg.append("svg:line")
            .attr("x1", x(lowerBound)) // x() converts a value into the pixel value in the chart
            .attr("y1", height)
            .attr("x2", x(lowerBound))
            .attr("y2", 0)
            .attr("stroke-dasharray", "4 1")
            .style("stroke", "rgb(255, 210, 0)")
            .attr("data-highlight", "highlight") // mark this as part of the highlight, so we can set it transparent later
            .attr("stroke-width", 1.5);

          // right line where range seleced ends
          svg.append("svg:line")
            .attr("x1", x(upperBound)) // x() converts a value into the pixel value in the chart
            .attr("y1", height)
            .attr("x2", x(upperBound))
            .attr("y2", 0)
            .attr("stroke-dasharray", "4 1")
            .style("stroke", "rgb(255, 210, 0)")
            .attr("data-highlight", "highlight") // mark this as part of the highlight, so we can set it transparent later
            .attr("stroke-width", 1.5);

        } else if (uidOfEmittingVueDistPreview == Vue.prototype.$globalSharedData.uidOfVueDistPreviewThatOwnsHighlight){

          // left line selected where range starts
          svg.append("svg:line")
            .attr("x1", x(parseFloat(Vue.prototype.$globalSharedData.lastSliderPositionLowerBoundAsString))) // x() converts a value into the pixel value in the chart
            .attr("y1", height)
            .attr("x2", x(parseFloat(Vue.prototype.$globalSharedData.lastSliderPositionLowerBoundAsString)))
            .attr("y2", 0)
            .attr("stroke-dasharray", "4 1")
            .style("stroke", "rgb(255, 210, 0)")
            .attr("data-highlight", "highlight") // mark this as part of the highlight, so we can set it transparent later
            .attr("stroke-width", 1.5);

          // right line where selected range ends
          svg.append("svg:line")
            .attr("x1", x(parseFloat(Vue.prototype.$globalSharedData.lastSliderPositionUpperBoundAsString))) // x() converts a value into the pixel value in the chart
            .attr("y1", height)
            .attr("x2", x(parseFloat(Vue.prototype.$globalSharedData.lastSliderPositionUpperBoundAsString)))
            .attr("y2", 0)
            .attr("stroke-dasharray", "4 1")
            .style("stroke", "rgb(255, 210, 0)")
            .attr("data-highlight", "highlight") // mark this as part of the highlight, so we can set it transparent later
            .attr("stroke-width", 1.5);
        }

        // The following does not seem necessary since this is already defined in normal plot

/*         svg.append("g")
          .call(d3.axisLeft(y)); */
          
/*         // Add x axis
        svg.append("g")
          .attr("transform", "translate(0," + height + ")")
          .call(d3.axisBottom(x)); */


        if (uidOfEmittingVueDistPreview != Vue.prototype.$globalSharedData.uidOfVueDistPreviewThatOwnsHighlight){

          // Only show highlight curve if this node is not the highlight owner where we use a rectangle

          // Plot the highlight curve
          if(Vue.prototype.$globalHighlightArray.length > 0 && typeof(lowerBound) == "undefined" && typeof(upperBound) == "undefined"){
            svg.append("path")
              .attr("class", "mypath")
              .datum(densityHighlight)
              .attr("fill", "#FFD200")
              .attr("data-highlight", "highlightCurve") // mark this as part of the highlight, so we can set it transparent later
              .attr("opacity", ".6")
              .attr("stroke", "#FFD200")
              .attr("stroke-width", 3)
              .attr("stroke-linejoin", "round")
              .attr("d",  d3.line()
              .curve(d3.curveBasis)
                .x(function(d) { return xHighlight(d[0]); })
                .y(function(d) { return yHighlight(d[1]); })
              )
          }
        }

        svg.append("svg:line")
          .attr("x1", x(arrayQuartile25)) // x() converts a value into the pixel value in the chart
          .attr("y1", height)
          .attr("x2", x(arrayQuartile25))
          .attr("y2", 0)
          .style("stroke", "#306484")
          .attr("stroke-width", 1);

        // let upper_quartile_line = 
        svg.append("svg:line")
          .attr("x1", x(arrayQuartile75)) // x() converts a value into the pixel value in the chart
          .attr("y1", height)
          .attr("x2", x(arrayQuartile75))
          .attr("y2", 0)
          .style("stroke", "#306484")
          .attr("stroke-width", 1);
        
        // let min_line = 
        svg.append("svg:line")
          .attr("x1", x(arrayMin)) // x() converts a value into the pixel value in the chart
          .attr("y1", height)
          .attr("x2", x(arrayMin))
          .attr("y2", 0)
          .style("stroke", "#306484")
          .attr("stroke-width", 1);

        // let max_line = 
        svg.append("svg:line")
          .attr("x1", x(arrayMax)) // x() converts a value into the pixel value in the chart
          .attr("y1", height)
          .attr("x2", x(arrayMax))
          .attr("y2", 0)
          .style("stroke", "#306484")
          .attr("stroke-width", 1);
        

        /* document.getElementById('highlightRangeFromField').value = arrayMin;
        document.getElementById('highlightRangeToField').value = arrayMax; */

        document.getElementById('popup-title').innerHTML = givenName;

        // Generate boxplots given the data matrix
        displayBoxPlot(matrixClone);


        if (this.isThisNodeHighlightOwner){
          
          // We need a timeout here so that the KL divergences can update
          // While this is waiting, we show a loading icon
          setTimeout(function(){ 
            self.showTopDrivers(); 
          });
         
        }

      },

      showTopDrivers() {

        /************************************************** 
          Update driver list
          -------------------
          We only do this if this node own the highlight
         **************************************************/

        // Determine which nodes are upstream and which are downstream compared to the current node
        // What is the current node's UUID?
        // We can probably do this using the node.id for now (which is not unique if a module has been embedded multiple times)
        // We need to process the global node data object: Vue.prototype.$globalSharedData.globalNodeData

        // console.log('This node\'s ID', this.idOfEmittingNode)

        // go to all nodes with this ID in the global node data object
        // then recursively fill a set with all nodes that are predecessors

        // Find all UUID nodes that have this node ID
        // In theory, it could be multiple nodes with the same node ID (but not UUID)
        let starting_nodes = [];
        for (let [nodeUUID, nodeInfo] of Object.entries(Vue.prototype.$globalSharedData.globalNodeData)) {
          // console.log(`${nodeUUID}: ${nodeInfo}`);
          if (nodeInfo.nodeID == this.idOfEmittingNode){
            starting_nodes.push(nodeUUID)
          }
        }
        
        // Create a set of all predecessor nodes using a recursive function
        let setOfPredecessorNodeUUIDs = new Set();
        let makeTree = (currentNodeUUID) => {
          let currentNode = Vue.prototype.$globalSharedData.globalNodeData[currentNodeUUID]
          currentNode.predecessors.forEach((element) => {
            setOfPredecessorNodeUUIDs.add(element);
            makeTree(element);
          });
        }

        // Call the recursive function for each starting node
        starting_nodes.forEach((element) => {
          makeTree(element);
        });

        // console.log('Predecessor nodes', setOfPredecessorNodeUUIDs)


        /************************************************* 
          Determine the list of the top X drivers
        **************************************************/

        // console.log('This node is the highlight owner.')

        // console.log('KL Divergence Array', Vue.prototype.$globalSharedData.klDivergenceArray)


        // This is used so we do not always add a graph but delete the old one
        // console.log(document.getElementById('driversBarplot'))
        if (document.getElementById('driversBarplot')){
          document.getElementById('driversBarplot').innerHTML = '';
        }

        // Create unique names for the KL divergence nodes
        let setOfUniqueNodeNames = new Set()
        for (let i = 0; i < Vue.prototype.$globalSharedData.klDivergenceArray.length; i++){

          let nodeFunction = Vue.prototype.$globalSharedData.klDivergenceArray[i].nodeFunction;
          let nodeName = Vue.prototype.$globalSharedData.klDivergenceArray[i].nodeNameForDriverList;

          // console.log('nodeFunction', nodeFunction)
          // console.log('nodeName', nodeName)

          let name = nodeName ? nodeName : nodeFunction;
          // console.log(name);

          if (!setOfUniqueNodeNames.has(name)){
            // If this name is not being used yet, then use it
            setOfUniqueNodeNames.add(name);
            Vue.prototype.$globalSharedData.klDivergenceArray[i].uniqueNodeNameForDriverList = name;
          
          } else {
            // If the name is already taken, then loop until the name is unique
            let counter = 2;
            let uniqueNodeNameForDriverList = name + " (" + counter + ")";

            // a while(true){} loop was not permitted by the linter
            for (let k = 0; k < Vue.prototype.$globalSharedData.klDivergenceArray.length; k++){
              if (setOfUniqueNodeNames.has(uniqueNodeNameForDriverList)){
                counter++;
                uniqueNodeNameForDriverList = name + " (" + counter + ")";
              } else {
                // Use the name and break the loop
                Vue.prototype.$globalSharedData.klDivergenceArray[i].uniqueNodeNameForDriverList = uniqueNodeNameForDriverList;
                setOfUniqueNodeNames.add(uniqueNodeNameForDriverList);
                break;
              }
            }
          }
        }

        // console.log('KL array after unique-y-fying', Vue.prototype.$globalSharedData.klDivergenceArray);

     
        /********************************************* 
          Prepare driver export
          ---------------------
          All nodes and their KL divergence
         *******************************************/

        // console.log('klDivergenceArray', Vue.prototype.$globalSharedData.klDivergenceArray);

        // Sort the array of objects by KLDivergence in descending order
        let klDivergenceArraySortedDescending = Vue.prototype.$globalSharedData.klDivergenceArray.sort(function (a, b) {
          return d3.descending(a.KLDivergence, b.KLDivergence);
        })

        // console.log('klDivergenceArraySortedDescending', klDivergenceArraySortedDescending);

        // Store the top drivers in a variable that we can export from
        let tempDriversForDownload = [['node ID', 'node title', 'KL Divergence']];

        for (let i = 0; i < klDivergenceArraySortedDescending.length; i++){
          // add a row for each driver
          tempDriversForDownload.push([
            klDivergenceArraySortedDescending[i].nodeID,
            klDivergenceArraySortedDescending[i].uniqueNodeNameForDriverList,
            klDivergenceArraySortedDescending[i].KLDivergence,
          ]);
        }
        // console.log('tempDriversForDownload', tempDriversForDownload)
        this.allDriversForExport = tempDriversForDownload;

        /********************************************* 
          Filter for predecessors (if user wishes it)
        **********************************************/

        // Only if the user selected show only predecessors, then we filter nodes first
        if (this.onlyShowPredecessors){
          // Filter out all nodes whose UUID is not in setOfPredecessorNodes
          let tempklDivergenceArraySortedDescending = []
          for (let j = 0; j < klDivergenceArraySortedDescending.length; j++){
            if (setOfPredecessorNodeUUIDs.has(klDivergenceArraySortedDescending[j].nodeUUID)){
              // If the node's UUID IS among the set of predecessors, then push it to temp array
              tempklDivergenceArraySortedDescending.push(klDivergenceArraySortedDescending[j]);
            }
          }

          // Now overwrite the variable to the new array
          klDivergenceArraySortedDescending = tempklDivergenceArraySortedDescending;
        }

        /************************************** 
          Select the TOP X drivers
        ***************************************/

        let topUpToXDrivers = []
        let maxNumberDrivers = SPURS.maxNumberOfDriversShown;

        // Now only take at most the maximum number fo drivers that we generally want to show (e.g. 10)
        for (let j = 0; j < Math.min(maxNumberDrivers, klDivergenceArraySortedDescending.length); j++){
          let currentObject = klDivergenceArraySortedDescending[j];
          if (currentObject.KLDivergence){
            // Only push if the object has a KLDivergence != undefined
            topUpToXDrivers.push(currentObject);
          }
        }

        this.topUpToXDrivers = topUpToXDrivers;
        // console.log(topUpToXDrivers);



        /************************************************************** 
          Attempt to plot a horizontal bar chart of the main drivers
        **************************************************************/

        if (topUpToXDrivers.length > 0) {
          // Only plot the graph if we have at least one driver

          // Sort bars based on value
          // Ascending results in the largest bar being on top = first
          topUpToXDrivers = topUpToXDrivers.sort(function (a, b) {
            return d3.ascending(a.KLDivergence, b.KLDivergence);
          })
          
          // set the dimensions and margins of the graph
          var marginDrivers = {top: 10, right: 30, bottom: 20, left: 100},
              widthDrivers = 200 - marginDrivers.left - marginDrivers.right,
              heightDrivers = 300 - marginDrivers.top - marginDrivers.bottom;

          // set the ranges
          var yDrivers = d3.scaleBand()
            .range([heightDrivers, 0])
            .padding(0.1);

          var xDrivers = d3.scaleLinear()
            .range([0, widthDrivers]);
                    
          // append the svg object to the body of the page
          // append a 'group' element to 'svg'
          // moves the 'group' element to the top left margin
          var svgDrivers = d3.select("#driversBarplot")
            .append("svg")
            .attr("width", widthDrivers + marginDrivers.left + marginDrivers.right)
            .attr("height", heightDrivers + marginDrivers.top + marginDrivers.bottom)
            .append("g")
            .attr("transform", 
                  "translate(" + marginDrivers.left + "," + marginDrivers.top + ")");

          // format the data
          topUpToXDrivers.forEach(function(d) {
            d.KLDivergence = +d.KLDivergence;
          });

          // Scale the range of the data in the domains
          xDrivers.domain([0, d3.max(topUpToXDrivers, function(d){ return d.KLDivergence; })])
          yDrivers.domain(topUpToXDrivers.map(function(d) { return d.uniqueNodeNameForDriverList; }));
          //y.domain([0, d3.max(data, function(d) { return d.sales; })]);

          // append the rectangles for the bar chart
          let bars = svgDrivers.selectAll(".bar")
            .data(topUpToXDrivers)
            .enter()
            .append("g")

          bars.append("rect")
            .attr("fill", "#51A7DD")
            .attr("opacity", "0.9")
            .attr("width", function(d) {return xDrivers(d.KLDivergence); } )
            .attr("y", function(d) { return yDrivers(d.uniqueNodeNameForDriverList); })
            .attr("height", yDrivers.bandwidth());

          // add the x Axis
          svgDrivers.append("g")
            .attr("transform", "translate(0," + heightDrivers + ")")
            .call(d3.axisBottom(xDrivers).ticks(4)); // set the number of ticks // .tickFormat(d3.format(".1e"))
          
          /* 
            // Add this to the x axis to rotate x axis labels
            .selectAll("text")  
            .style("text-anchor", "end")
            .attr("dx", "-.8em")
            .attr("dy", ".15em")
            .attr("transform", "rotate(-45)" )
          */

          // add the y Axis
          svgDrivers.append("g")
            .call(d3.axisLeft(yDrivers));

          // Add x axis name
          /*   
            svg.append("text")             
            .attr("transform",
                  "translate(" + (widthDrivers/2) + " ," + 
                                (heightDrivers + marginDrivers.top + 20) + ")")
            .style("text-anchor", "middle")
            .text("KL Divergence");   
          */

          //add a value label to the right of each bar
          bars.append("text")
            .attr("font-size", "10")
            //y position of the label is halfway down the bar
            .attr("y", function (d) {
                return yDrivers(d.uniqueNodeNameForDriverList) + yDrivers.bandwidth() / 2 + 4;
            })
            //x position is 3 pixels to the right of the bar
            .attr("x", function (d) {
                return xDrivers(d.KLDivergence) + 3;
            })
            .text(function (d) {
                return new Intl.NumberFormat('en-US', {maximumFractionDigits: 3}).format(d.KLDivergence);
            });
        }

      },

      periodSliderChanged() {

        // console.log('selected periods', this.periodSliderSelectedPeriods)
        // console.log('periodSliderData', this.periodSliderData)
        // console.log('Should be different than: ', this.value)

        let result = updateChangeDrivers(this.periodSliderSelectedPeriods[0] - 1, this.periodSliderSelectedPeriods[1] - 1, this.idOfEmittingNode, this.activeModule, this.modules, this.matrixCloneForDownload); // we are zero indexed later; and upper bound is incl.

        this.summed_statistics_quartile25 = result.valTotalsQuartile25FormattedString;
        this.summed_statistics_mean = result.valTotalsMeanFormattedString;
        this.summed_statistics_median = result.valTotalsMedianFormattedString;
        this.summed_statistics_quartile75 = result.valTotalsQuartile75FormattedString;
        this.summed_statistics_stdev = result.valTotalsStdevFormattedString;

        // In any case, this node now becomes owner of the period selection
        Vue.prototype.$globalSharedData.idOfNodeThatOwnsPeriodSelection = this.idOfEmittingNode;
        // TODO: Not sure about this one....
        Vue.prototype.$globalSharedData.uidOfVueDistPreviewThatOwnsHighlight = this.uidOfEmittingVueDistPreview;  

        // If this node is NOT already highlight owner, then we need to reset the highlight
        if (!this.isThisNodeHighlightOwner){
          Vue.prototype.$globalSharedData.idOfNodeThatOwnsHighlight = undefined;
          Vue.prototype.$globalTempHighlightArray = [];
          Vue.prototype.$globalHighlightArray = [];

          // Make highlighted parts invisible
          // Set all element in the SVG to transparent that relate to highlights
          // These elements got a data-highlight attribute when they were created :)
          let highlight_elements = document.querySelectorAll('[data-highlight="highlightCurve"]');
          highlight_elements.forEach( x=> x.setAttribute("opacity","0"))

        } 

        // Store the slider positions in a global variable
        Vue.prototype.$globalSharedData.lastPeriodSliderPositionLowerBoundAsString = this.periodSliderSelectedPeriods[0];
        Vue.prototype.$globalSharedData.lastPeriodSliderPositionUpperBoundAsString = this.periodSliderSelectedPeriods[1];

        updateHighlightsAndKL();


      },

      sliderChanged() {

        // This gets executed whenever the range slider is changed
        // console.log('slider changed')
        // console.log('popup when slider was changed', this)

        // Empty the array with the KL Divergences to create a clean slate
        Vue.prototype.$globalSharedData.klDivergenceArray = [];

        // For whatever reason, the slider component returns strings that need to be cast first
        let lowerBound = parseFloat(this.value[0]);
        let upperBound = parseFloat(this.value[1]);
        let lowerBoundAsString = this.value[0];
        let upperBoundAsString = this.value[1];

        // If this popup is NOT already highlight owner, then we need to update the previously set period slider positions to default
        if (Vue.prototype.$globalSharedData.uidOfVueDistPreviewThatOwnsHighlight != this.uidOfEmittingVueDistPreview){
          Vue.prototype.$globalSharedData.lastPeriodSliderPositionLowerBoundAsString = '1';
          Vue.prototype.$globalSharedData.lastPeriodSliderPositionUpperBoundAsString = '1';
        }

        // By changing the slider, this node becomes owner for highlight and period selection
        Vue.prototype.$globalSharedData.idOfNodeThatOwnsHighlight = this.idOfEmittingNode;
        Vue.prototype.$globalSharedData.idOfNodeThatOwnsPeriodSelection = this.idOfEmittingNode;
        Vue.prototype.$globalSharedData.uidOfVueDistPreviewThatOwnsHighlight = this.uidOfEmittingVueDistPreview;
        
        
        // The stored values need to be strings
        Vue.prototype.$globalSharedData.lastSliderPositionLowerBoundAsString = lowerBoundAsString;
        Vue.prototype.$globalSharedData.lastSliderPositionUpperBoundAsString = upperBoundAsString;

        let givenName = Vue.prototype.$globalSharedData.nameOfNodeThatOwnsHighlight;
        if (typeof givenName == 'undefined'){
          givenName = Vue.prototype.$globalSharedData.defaultPopupName;
        }

        updateHighlightsAndKL();
 
        plotDetailPopUpGraph(Vue.prototype.$globalTempHighlightArray, givenName, lowerBound, upperBound, this.idOfEmittingNode, this.uidOfEmittingVueDistPreview);

        let result = updateChangeDrivers(this.periodSliderSelectedPeriods[0] - 1, this.periodSliderSelectedPeriods[1] - 1, this.idOfEmittingNode, this.activeModule, this.modules, this.matrixCloneForDownload); // we are zero indexed later; and upper bound is incl.

        this.summed_statistics_quartile25 = result.valTotalsQuartile25FormattedString;
        this.summed_statistics_mean = result.valTotalsMeanFormattedString;
        this.summed_statistics_median = result.valTotalsMedianFormattedString;
        this.summed_statistics_quartile75 = result.valTotalsQuartile75FormattedString;
        this.summed_statistics_stdev = result.valTotalsStdevFormattedString;
      
      },
      closeModal(){
        this.$emit("update-popup-data", false);
        this.dataWatcher();
      },
      download_data(strDesiredData){

        if (strDesiredData == 'density') {

          // This will prepare for download:
          // the probability density function (with 50 or so value pairs)

          const rows = [
            ["density_x", "density_y", "highlight_x", "highlight_y"]
          ];

          for (let i = 0; i < this.density.length; i++){

              // If this is NOT the node that owns the highlight, then we can export a highlight curve
              // Otherwise, this would only be a range, not actual samples
              // The highlight can also be undefined (which is the case before a node becomes highlight owner)
              if (typeof Vue.prototype.$globalSharedData.idOfNodeThatOwnsHighlight == "undefined"){
                rows.push([...this.density[i], 'highlight was not defined', 'highlight was not defined'])
              } else if (this.idOfEmittingNode != Vue.prototype.$globalSharedData.idOfNodeThatOwnsHighlight){
                rows.push([...this.density[i], ...this.densityHighlight[i]]) // this is an array of 4 elements, i.e. x/y pairs from both distributions
              } else {
                rows.push([...this.density[i], 'highlight not availabe (this node defined the range)', 'highlight not availabe (this node defined the range)'])
              }
              
          }
          
          let csvContent = "";
          
          rows.forEach(function(rowArray) {
            let row = rowArray.join(",");
            csvContent += row + "\r\n";
          });

          download(csvContent, 'probability_density.csv', 'text/csv;charset=utf-8;');
          
        } else if (strDesiredData == 'rawdata') {

          // This will prepare for download:
          // all samples generated for this node for all time periods
          // the number of rows = # time slices * # samples

          let list_of_periods = [];

          for (let timeSlice = 0; timeSlice < this.matrixCloneForDownload.length; timeSlice++){
            list_of_periods.push('period_' + (timeSlice + 1))
          }

          const rows = [
            [list_of_periods]
          ];

          for (let i = 0; i < this.matrixCloneForDownload[0].length; i++){
            // Iterate over number of samples using first period as basis

            let list_of_values = [] // same number of values as there are periods

            for (let timeSlice = 0; timeSlice < this.matrixCloneForDownload.length; timeSlice++){
            // Iterate over time slices
                list_of_values.push(this.matrixCloneForDownload[timeSlice][i]) // this is an array with two elements
            }
            rows.push(list_of_values)
          }
          
          let csvContent = "";
          
          rows.forEach(function(rowArray) {
            let row = rowArray.join(",");
            csvContent += row + "\r\n";
          });

          download(csvContent, 'raw_data.csv', 'text/csv;charset=utf-8;');
          
        } else if (strDesiredData == 'drivers') {
        
          let csvContent = "";
          
          this.allDriversForExport.forEach(function(rowArray) {
            let row = rowArray.join(",");
            csvContent += row + "\r\n";
          });

          download(csvContent, 'all_drivers.csv', 'text/csv;charset=utf-8;');
          
        } else if (strDesiredData == 'boxplots'){

          // Get an array of all statistics we are provided with
          let listOfVariables = []
          Object.entries(this.statisticsForDownload).forEach(entry => {
            listOfVariables.push(entry[0]);
          });

          // This is the array of arrays that will become the CSV contents
          const rows = [
            ['period', ...listOfVariables] // use spread operator to get all elements
          ];

          // console.log(this.statisticsForDownload)

          // determine how many time slices we have
          let numberOfTimeSlices = this.matrixCloneForDownload.length;

            for (let timeSlice = 0; timeSlice < numberOfTimeSlices; timeSlice++){

              // Iterate over time slices

              // Iterate over variables
              let single_row = [timeSlice +1] // array pre-filled with the period

              Object.entries(this.statisticsForDownload).forEach(entry => {

                single_row.push(entry[1][timeSlice]); // entry[1] is the value array for this variable with as many entries as timeSlices

              });

              rows.push(single_row);

            }

          // Iterate over variables
          let single_row = ['sum_over_all_periods'] // array pre-filled with the period

          Object.entries(this.statisticsForDownload).forEach(entry => {

            single_row.push(entry[1][this.matrixCloneForDownload.length]); // this is the last value in the array, which is the value for the sum of all arrays

          });

          rows.push(single_row);  

          let csvContent = "";
          
          rows.forEach(function(rowArray) {
            let row = rowArray.join(",");
            csvContent += row + "\r\n";
          });

          download(csvContent, 'boxplot_data.csv', 'text/csv;charset=utf-8;');

        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  /* Popup Box */
  #popupBox {
    z-index: 100;
  }

  /* mPopup box style */
  .popup {
    position: fixed;
    z-index: 1;
    padding-top: 50px;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgb(0,0,0);
    background-color: rgba(0,0,0,0.4);
  }

  .popup-content {
    position: relative;
    background-color: #fefefe;
    margin: auto;
    padding: 0;
    width: 1360px; /* xx more than required by columns */
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19);
    -webkit-animation-name: animatetop;
    -webkit-animation-duration: 0.4s;
    animation-name: animatetop;
    animation-duration: 0.4s
  }

  .popup-header {
    padding: 2px 16px;
    background-color: #51A7DD;
    color: white;
  }

  .popup-main {
    /* This is the part of the pop-up underneath the pop-up header */

    padding: 10px 10px;
    /* overflow:auto; */

    /* Grid template */
    display: grid;
    column-gap: 10px;
    row-gap: 20px;
    grid-template-columns: 125px 125px 125px 125px 125px 125px 125px 125px 125px 125px; /* 10 columns */
  }

  .popup-footer {
    padding: 2px 16px;
    background-color: #999999;
    color: #ffffff;
    font-family: monospace;
    font-size: 12px;
  }

  .plot{
    float:left;
    width: 100%;
    height: 100%;
  }

  .largesvgplot{
    float: right;
  }


  .popup_box_title_container {

    background-color: #51a7dd;
    color: white;
    height: 20px;
    width: 100%;
    display: inline-block;
    vertical-align: middle;
    padding: 0px 5px;
    box-sizing: border-box;
  }

  /* The following rows can be simplified using inheritance */

  #popup_gridItem_distribution {
  /*   border-style: solid;
    border-width:0.5px;
    border-color: darkgray;
    background-color: #F5F8FD; */
    box-sizing: border-box;
    grid-column-start: 1;
    grid-column-end: 5; /* exclusively */
    height: 400px;
    margin:0px;
    padding:0px;
  }

  #popup_gridItem_boxplot  {
  /*   border-style: solid;
    border-width:0.5px;
    border-color: darkgray;
    background-color: #F5F8FD;  */
    box-sizing: border-box;
    grid-column-start: 5;
    grid-column-end: 11; /* exclusively, hence one more than exist */
    height: 400px;
    margin:0px;
    padding:0px;
  }

  #popup_gridItem_highlightSlider {
  /*   border-style: solid;
    border-width:0.5px;
    border-color: darkgray;
    background-color: #F5F8FD; */
    box-sizing: border-box;
    grid-column-start: 1;
    grid-column-end: 5; /* exclusively */
    height: 140px;
    margin:0px;
    padding:0px;
  }

  #popup_gridItem_changeDriverSlider  {
  /*   border-style: solid;
    border-width:0.5px;
    border-color: darkgray;
    background-color: #F5F8FD; */
    box-sizing: border-box;
    grid-column-start: 5;
    grid-column-end: 11; /* exclusively */
    height: 140px;
    margin:0px;
    padding:0px;
  }

  #popup_gridItem_differenceToHighlight {
  /*   border-style: solid;
    border-width:0.5px;
    border-color: darkgray;
    background-color: #F5F8FD; */
    box-sizing: border-box;
    grid-column-start: 1;
    grid-column-end: 3; /* exclusively */
    height: 200px;
    margin:0px;
    padding:0px;
  }

  #popup_gridItem_topDrivers {
  /*   border-style: solid;
    border-width:0.5px;
    border-color: darkgray;
    background-color: #F5F8FD; */
    box-sizing: border-box;
    margin:0px;
    padding:0px;
    /* If we want this box to start (and end) in the second column and stretch from the second to the third column incl. */
/*     grid-row-start:    2;
    grid-row-end:      4; */
    grid-column-start: 3;
    grid-column-end:   5;
  }

  #popup_gridItem_statistics {
  /*   border-style: solid;
    border-width:0.5px;
    border-color: darkgray;
    background-color: #F5F8FD; */
    box-sizing: border-box;
    grid-column-start: 5;
    grid-column-end: 8; /* exclusively */
    height: 200px;
    margin:0px;
    padding:0px;
  }

  #popup_gridItem_topDriversOfChange {
  /*   border-style: solid;
    border-width:0.5px;
    border-color: darkgray;
    background-color: #F5F8FD; */
    box-sizing: border-box;
    grid-column-start: 8;
    grid-column-end: 11; /* exclusively */
    height: 200px;
    margin:0px;
    padding:0px;    
  }

  #popup_gridItem_download {
  /*   border-style: solid;
    border-width:0.5px;
    border-color: darkgray;
    background-color: #F5F8FD; */
    box-sizing: border-box;
    grid-column-start: 1;
    grid-column-end: 5; /* exclusively */
    height: 150px;
    margin:0px;
    padding:0px;
  }

  #popup_gridItem_comment {
  /*   border-style: solid;
    border-width:0.5px;
    border-color: darkgray;
    background-color: #F5F8FD; */
    box-sizing: border-box;
    grid-column-start: 5;
    grid-column-end: 11; /* exclusively */
    height: 150px;
    margin:0px;
    padding:0px;
  }


  /* close button style */
  .close {
    color: white;
    float: right;
    font-size: 28px;
    font-weight: bold;
  }
  .close:hover, .close:focus {
    color: #000;
    text-decoration: none;
    cursor: pointer;
  }

  .highlight-controlgroup {
    margin-bottom: .5em;
    font-size: smaller;
  }

  .highlight-controlgroup label {
    text-align: right;
    display: inline-block;
    vertical-align: middle;
    width: 4em;
    margin: 0 1em 0 0;
  }

  .highlight-form input[type=number] {
    padding: .5em .6em;
    display: inline-block;
    border: 1px solid #ccc;
    -webkit-box-shadow: inset 0 1px 3px #ddd;
    box-shadow: inset 0 1px 3px #ddd;
    border-radius: 4px;
    vertical-align: middle;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .button {
    font-family: inherit;
    font-size: 100%;
    padding: .5em 1em;
    color: #444;
    color: rgba(0,0,0,.8);
    border: 1px solid #999;
    border: none transparent;
    background-color: #e6e6e6;
    text-decoration: none;
    border-radius: 2px;
  }

  .button:hover{
    cursor: pointer;
  }

  .inline-element .button {
    margin-top: -.2em;
  }

  .highlight-button {
    margin-left: 5em;
  }

  .boxplot {
    font: 10px sans-serif;
  }

  .boxplot line, .boxplot rect, .boxplot circle {
    fill: steelblue;
    stroke: #000;
    stroke-width: 1px;
  }

  .boxplot .center {
    stroke-dasharray: 3,3;
  }

  .boxplot .outlier {
    fill: none;
    stroke: #000;
  }

  .axis {
    font: 12px sans-serif;
  }
  
  .axis path,
  .axis line {
    fill: none;
    stroke: #000;
    shape-rendering: crispEdges;
  }
  
  .x.axis path { 
    fill: none;
    stroke: #000;
    shape-rendering: crispEdges;
  } 

  textarea {
    height: auto;
    margin-top: 5px;
    font-family:sans-serif;
    width: 395px;
  }

  .loading {
    width: 50px;
    height: 50px;
    display:block;
    margin:auto;
  }

  .tg {
    border-collapse:collapse;
    border-spacing:0;
    width: 100%;
    color: black;
  }
  .tg td {
/*     border-color:black;
    border-style:solid;
    border-width:1px; */
    font-size: smaller;
    overflow:hidden;
    padding:3px 5px;
    word-break:normal;
  }
  .tg tr {
    border-bottom: 1px solid #ededed;
  }
  .tg th{
/*     border-color:black;
    border-style:solid;
    border-width:1px; */
    font-size:14px;
    font-weight:bold;
    overflow:hidden;
    padding:3px 5px;
    word-break:normal;
    background-color: #ededed;
  }
  .tg .tg-0lax{
    text-align:right;
    vertical-align:top
  }


  /* Overwrite some aspects of the tooltip classes */

  .tooltip .tooltiptext {
    width: 300px;
    margin-left: -155px;
    padding: 5px 5px;
  }

    /* highlight indicator: if yellow, then this node defines highlight */
  .dot {
    height: 20px;
    width: 20px;
    background-color: yellow;
    border-radius: 50%;
    border-style: solid;
    border-color: grey;
    border-width: thin;
    display: inline-block;

  }

</style>
